/**
 * @generated SignedSource<<1e7155b568225a121320e60ea6345f18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MediaType = "cast" | "ins_highlight" | "ins_image" | "ins_live" | "ins_story" | "ins_video" | "other" | "tiktok" | "twitter_image" | "twitter_video" | "youtube";
export type ParentMediaType = "cast" | "instagram" | "other" | "tiktok" | "twitter" | "youtube";
import { FragmentRefs } from "relay-runtime";
export type SNSBadge_mediaType$data = {
  readonly mediaType: MediaType;
  readonly parentMediaType: ParentMediaType;
  readonly " $fragmentType": "SNSBadge_mediaType";
};
export type SNSBadge_mediaType$key = {
  readonly " $data"?: SNSBadge_mediaType$data;
  readonly " $fragmentSpreads": FragmentRefs<"SNSBadge_mediaType">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SNSBadge_mediaType",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentMediaType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaType",
      "storageKey": null
    }
  ],
  "type": "Campaign",
  "abstractKey": null
};

(node as any).hash = "a88953796745c5d66984440625bde397";

export default node;
